import { render, staticRenderFns } from "./ExternalTab.vue?vue&type=template&id=557688f8&scoped=true&"
import script from "./ExternalTab.vue?vue&type=script&lang=js&"
export * from "./ExternalTab.vue?vue&type=script&lang=js&"
import style0 from "./ExternalTab.vue?vue&type=style&index=0&id=557688f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557688f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
